import { environment } from '../environments/environment';

export class AppConfig {
  public static readonly HOME_API: string = environment.homeApi;

  // URL NUEVOS FIRMWARES
  public static readonly FIRM_URL: string = environment.firmUrl;

  public static readonly CAPTCHA_KEY = {
    //"localhost:4200": "6LfCkwUgAAAAAPQ7v8sq_vRH9428zKlkaJFCQc1n",
    //"localhost:4200": "6LfEbZ4qAAAAAANSwPKRm-KT-IMzvpWELTYx8eLD", // v2
    "localhost:4200": "6Ldkw8gqAAAAANRJ6JXxnm-GTEuetSbndOoGwKfx", // v3

    //"test.poolstation.net": "6LfCkwUgAAAAAPQ7v8sq_vRH9428zKlkaJFCQc1n",
    //"test.idegis.net": "6LdGB6wUAAAAAJzrMBMbHnOoVivFEXMzVH4aa7CS", // v2
    "test.poolstation.net": "6Ldkw8gqAAAAANRJ6JXxnm-GTEuetSbndOoGwKfx", // v3
    "test.idegis.net": "6Ldkw8gqAAAAANRJ6JXxnm-GTEuetSbndOoGwKfx", // v3

    //"poolstation.net": "6LcJkqIgAAAAANCD1r2ABbfsms-1K7ENFBYxmRe9", // v2
    //"idegis.net": "6LcJkqIgAAAAANCD1r2ABbfsms-1K7ENFBYxmRe9", // v2
    "poolstation.net": "6Lcf79QqAAAAABUTSXWhDiT3Z8DxH2qZlk08SNkF", // v3
    "idegis.net": "6Lcf79QqAAAAABUTSXWhDiT3Z8DxH2qZlk08SNkF", // v3

    "pre.poolstation.net": "6Lcf79QqAAAAABUTSXWhDiT3Z8DxH2qZlk08SNkF",
    "pre.idegis.net": "6Lcf79QqAAAAABUTSXWhDiT3Z8DxH2qZlk08SNkF"
  };
}
